import React, { ReactElement } from 'react'
import styled from 'styled-components'
import GridButton from '../../../buttons/GridButton'
import { IColorTheme } from '../../../types/itemTypes'
import {
  ICategoryResponse,
  SubCategoryFormat,
} from '../../../types/organisation'

const Styles = styled.div`
  margin: 20px auto;
  max-width: 1068px;
  padding: 0 25px;
  @media (max-width: 320px) {
    padding: 0 5px;
  }

  display: flex;
  justify-content: center;
  gap: 10px;
  @media (max-width: 400px) {
    flex-direction: column;
    align-items: stretch;
  }

  ${({ theme: { format, number } }): string => {
    if (number < 3) return 'flex-wrap: wrap;'

    if (format === SubCategoryFormat.Grid) {
      return `
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      justify-content: center;
      gap: 10px;
      @media (max-width: 550px) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media (max-width: 400px) {
        grid-template-columns: 1fr;
      }
`
    }

    return ''
  }};
`

interface ISubCategoriesProps {
  subCategories: ICategoryResponse[]
  selectedSubCategoryId: number | undefined
  setSelectedSubCategoryId: (subCategoryId: number | undefined) => void
  colorTheme?: Partial<IColorTheme>
  format?: SubCategoryFormat
}
export default function SubCategories(
  props: ISubCategoriesProps,
): ReactElement {
  const {
    subCategories,
    selectedSubCategoryId,
    setSelectedSubCategoryId,
    colorTheme,
    format,
  } = props

  const number = subCategories.length

  return (
    <Styles theme={{ number, format }}>
      <GridButton
        theme={colorTheme}
        onClick={(): void => setSelectedSubCategoryId(undefined)}
        className={!selectedSubCategoryId ? 'active' : ''}
      >
        Show all
      </GridButton>
      {subCategories.map((category) => (
        <GridButton
          theme={colorTheme}
          key={category.id}
          onClick={(): void => setSelectedSubCategoryId(category.id)}
          className={category.id === selectedSubCategoryId ? 'active' : ''}
        >
          {category.title}
        </GridButton>
      ))}
    </Styles>
  )
}
